import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation/events",
  "use": "navigation/events-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"navigation/events\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 .003a1 1 0 0 0-1 1v1h-.5a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-10a1.5 1.5 0 0 0-1.5-1.5H13v-1a1 1 0 0 0-2 0v1H5v-1a1 1 0 0 0-1-1zm-1 6v7h10v-7H3zm8.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol